import ScrollReveal from "@/components/feature/ScrollReveal";
import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES } from "@/mocks/site";
import { chefPicks, papasAddition } from "@/mocks/menu";

export default function ChefPicks() {
  return (
    <section id="carta" className="w-full bg-background-50 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-10">
        <ScrollReveal className="max-w-3xl">
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-accent-500">
            La carta
          </p>
          <h2 className="mt-4 font-heading text-4xl leading-[1.05] text-foreground-950 md:text-6xl">
            Recomendados de la chef
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            Diana Cerón selecciona lo que no te puedes perder.
          </p>
        </ScrollReveal>

        <div className="mt-12 grid grid-cols-1 gap-8 md:mt-16 md:grid-cols-2 md:gap-10">
          {chefPicks.map((dish, index) => (
            <ScrollReveal key={dish.id} delay={(index % 2) * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-secondary-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1">
                <div className="relative aspect-square w-full overflow-hidden">
                  <img
                    src={dish.image}
                    alt={`Sando de autor: ${dish.name}`}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  {dish.tag ? (
                    <span className="absolute left-4 top-4 rounded-full bg-background-50/95 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.15em] text-accent-700">
                      {dish.tag}
                    </span>
                  ) : null}
                </div>

                <div className="flex flex-1 flex-col p-5 md:p-7">
                  <h3 className="font-heading text-2xl text-foreground-950 md:text-3xl">
                    {dish.name}
                  </h3>
                  <p className="mt-2 font-heading text-2xl font-semibold text-primary-500 md:text-3xl">
                    {dish.price}
                  </p>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600 md:text-base">
                    {dish.description}
                  </p>
                  <a
                    href={whatsappUrl(`${WA_MESSAGES.dishPrefix}${dish.name}.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex min-h-[48px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600 md:text-base"
                  >
                    <i className="ri-whatsapp-line text-lg" aria-hidden="true" />
                    Pedir este por WhatsApp
                  </a>
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal className="mt-10">
          <div className="flex flex-col items-start justify-between gap-3 rounded-lg border border-secondary-200 bg-background-100 px-5 py-5 sm:flex-row sm:items-center md:px-8">
            <span className="flex items-center gap-3 font-heading text-xl text-foreground-950 md:text-2xl">
              <i className="ri-add-line text-primary-500" aria-hidden="true" />
              {papasAddition.name}
            </span>
            <span className="font-heading text-xl font-semibold text-primary-500 md:text-2xl">
              {papasAddition.price}
            </span>
          </div>
        </ScrollReveal>

        <ScrollReveal className="mt-8">
          <p className="max-w-3xl text-xs leading-relaxed text-foreground-600 md:text-sm">
            Las porciones son generosas. Precios incluyen impuesto al consumo del 8%. El servicio de
            propina es voluntario (ley 1935 de 2018). Si tienes alguna alergia o intolerancia,
            escríbenos y te asesoramos.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}